export default __webpack_public_path__ + "static/media/users.5dd50138.svg";